// context/ThemeContext.js
import {createContext, useContext, useEffect, useState} from 'react';
import {ThemeProvider as StyledThemeProvider} from 'styled-components';
import {mergeThemes} from '../shared/themeUtils';
import {ClientContext} from "./ClientContext";
import musixTheme from "../shared/musixTheme";
import venoaTheme from "../shared/venoaTheme";
import baseTheme from "../shared/baseTheme";

const ThemeContext = createContext(null);

export const CustomThemeProvider = ({children}: any) => {
  const {clientCtx} = useContext(ClientContext)
  const [theme, setTheme] = useState(mergeThemes(baseTheme, {}));

  useEffect(() => {
    if (clientCtx) {
      if (clientCtx.divisionCode == 'mus') {
        setTheme(mergeThemes(baseTheme, musixTheme));
      } else {
        setTheme(mergeThemes(baseTheme, venoaTheme));
      }
    }
  }, [clientCtx]);

  return (
    <ThemeContext.Provider value={theme}>
      <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
    </ThemeContext.Provider>
  );
};